// if (!customElements.get('product-inventory')) {
//   class ProductInventory extends HTMLElement {
//     constructor() {
//       super();
//       window.initLazyScript(this, this.initLazySection.bind(this));
//     }

//     initLazySection() {
//       this.inventoryNotice = this.querySelector('.js-inventory-notice');
//       this.urgencyMessage = this.querySelector('.js-inventory-urgency');
//       this.indicatorBar = this.querySelector('.js-inventory-indicator');
//       this.variantInventory = this.getVariantInventory();

//       // Bind to on:variant:change event for this product
//       const variantPicker = this.closest('.product-info').querySelector('variant-picker');
//       if (variantPicker) {
//         variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
//       }

//       // Init
//       this.updateInventory(
//         parseInt(this.dataset.inventoryQuantity, 10),
//         this.dataset.variantAvailable === 'true',
//         this.dataset.inventoryPolicy
//       );
//     }

//     /**
//      * Gets the inventory data for all product variants
//      * @returns {?object}
//      */
//     getVariantInventory() {
//       const dataEl = this.querySelector('[type="application/json"]');
//       return this.variantInventory || JSON.parse(dataEl.textContent);
//     }

//     /**
//      * Handles a 'change' event on the variant picker element
//      * @param {object} evt - Event object
//      */
//     handleVariantChange(evt) {
//       if (evt.detail.variant) {
//         const inventory = this.variantInventory.filter(
//           (variant) => variant.id === evt.detail.variant.id
//         )[0];
//         this.updateInventory(
//           inventory.inventory_quantity,
//           inventory.available,
//           inventory.inventory_policy
//         );
//       } else {
//         this.updateInventory(0, false);
//         this.hidden = true;
//       }
//     }

//     /**
//      *
//      * Updates the inventory notice
//      * @param {number} count - the inventory quantity available
//      * @param {boolean} available - whether current variant is available
//      * @param {string} inventoryPolicy - whether product continues selling when out of stock
//      */
//     updateInventory(count, available, inventoryPolicy) {
//       let inventoryLevel;

//       if (count <= 0) {
//         if (inventoryPolicy === 'continue') {
//           inventoryLevel = 'backordered';
//         } else if (available) {
//           console.log('hello');
//           inventoryLevel = 'in_stock';
//         } else {
//           inventoryLevel = 'none';
//         }
//       } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
//         inventoryLevel = 'very_low';
//       } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
//         inventoryLevel = 'low';
//       } else {
//         inventoryLevel = 'normal';
//       }

//       if (((this.dataset.showNotice === 'always'
//         || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
//         && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
//         this.hidden = false;

//         // Set the inventory level data attribute
//         this.setAttribute('data-inventory-level', inventoryLevel);

//         // Determine whether to show the count or not
//         if (inventoryLevel === 'backordered') {
//           this.inventoryNotice.innerText = '';
//         } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
//           this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
//         } else if (inventoryLevel === 'very_low') {
//           this.inventoryNotice.innerText = theme.strings.veryLowStock;
//         } else if (inventoryLevel === 'low') {
//           this.inventoryNotice.innerText = theme.strings.lowStock;
//         } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
//           this.inventoryNotice.innerText = theme.strings.inStock;
//         } else if (inventoryLevel === 'none') {
//           this.inventoryNotice.innerText = theme.strings.noStock;
//         }

//         // Update urgency message if needed
//         if (this.urgencyMessage) {
//           if (inventoryLevel === 'very_low') {
//             this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
//           } else if (inventoryLevel === 'low') {
//             this.urgencyMessage.innerHTML = this.dataset.textLow;
//           } else if (inventoryLevel === 'backordered') {
//             this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
//           } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
//             this.urgencyMessage.innerHTML = this.dataset.textNormal;
//           } else if (inventoryLevel === 'none') {
//             this.urgencyMessage.innerHTML = this.dataset.textNoStock;
//           }
//         }

//         // Update the bar indicator
//         if (this.indicatorBar) {
//           this.indicatorBar.hidden = false;

//           let newWidth;
//           if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
//             newWidth = 100;
//           } else {
//             newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
//           }
//           this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
//         }
//       } else {
//         this.hidden = true;
//       }
//     }
//   }

//   customElements.define('product-inventory', ProductInventory);
// }


if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      // If it's a recommendation or related section, use non-variant logic
      if (this.closest('.cc-product-recommendations') || this.closest('.related-products')) {
        this.runNonVariantPageCode();
      } 
      // If it's a product page (template-product), use the variant-based logic
      else if (document.body.classList.contains('template-product')) {
        this.runProductPageCode();
      } 
      // For all other pages, use the non-variant logic
      else {
        this.runNonVariantPageCode();
      }
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Code to run on product page with variant picker
     */
    runProductPageCode() {
      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init the inventory display for product pages
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Code to run on non-product pages (no variant picker) or recommendation sections
     */
    runNonVariantPageCode() {
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
